/*
 * *
 *   ~  * Copyright (c) by INFODATA-GROUP. All rights reserved.
 *   ~  * No part of this publication may be reproduced, distributed,
 *   ~  * or transmitted in any form or by any means, including photocopying, recording,
 *   ~  * or other electronic or mechanical methods, without the prior written permission of the publisher,
 *   ~  * except in the case of brief quotations embodied in critical
 *   ~  * reviews and certain other noncommercial uses permitted by copyright law.
 *   ~  * AUTHOR : bs
 *   ~  * DATE : 15/05/2025 17:23
 *
 */

import { HTTP_INTERCEPTORS, HttpBackend } from '@angular/common/http';
import {
  EnvironmentProviders,
  ImportProvidersSource,
  Provider,
} from '@angular/core';
import { GoogleMapsModule } from '@angular/google-maps';
import {
  ConfigLoader,
  DefaultConfigLoader,
  HttpLoaderTranslation,
  OAuthInterceptor,
  RestService,
  ServerSettingsService,
  SettingsService,
  W3hostnameInterceptor,
} from '@infodata-group/inf-commons';
import { CustomRestService } from '@monorepo-projects/alwayson-shared';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { EditorModule } from '@tinymce/tinymce-angular';

export const commonsProvidersFrom: ImportProvidersSource[] = [
  TranslateModule.forRoot({
    loader: {
      provide: TranslateLoader,
      useFactory: HttpLoaderTranslation,
      deps: [HttpBackend],
    },
  }),
  GoogleMapsModule,
  EditorModule,
];

export const commonsProviders: Array<Provider | EnvironmentProviders> = [
  { provide: ConfigLoader, useClass: DefaultConfigLoader },
  { provide: SettingsService, useClass: ServerSettingsService },
  { provide: RestService, useClass: CustomRestService },
  { provide: HTTP_INTERCEPTORS, useClass: OAuthInterceptor, multi: true },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: W3hostnameInterceptor,
    multi: true,
  },
];
